<template>
  <div id="expertAssessIndex">
    <div class="fitPc">
      <h3>评审管理</h3>
      <div class="tabs">
        <div class="tabsItem" @click="handleTabs(item)" :class="{ activr: item.id == parame.status }" v-for="(item, index) in tabs.data" :key="`${index}a`">
          {{ item.name }}
        </div>
        <el-input size="small" style="width: 40%; margin-left: auto" placeholder="请输入你需要搜索的内容" v-model="parame.keyWords" clearable> </el-input>
      </div>
      <!-- 列表 -->
      <div class="table" v-loading="loading" element-loading-text="拼命加载中">
        <el-table stripe :data="tableData" ref="table" @row-click="rowClick">
          <!-- 评审ID -->
          <el-table-column prop="recordNumber" min-width="50px" label="评审ID" align="center"></el-table-column>
          <!-- 用户	-->
          <el-table-column prop="userName" min-width="120px" label="用户" align="center"></el-table-column>
          <!-- 目前所涉及的行业 -->
          <el-table-column prop="category" min-width="90px" label="目前所涉及的行业" align="center"></el-table-column>
          <!-- 评审类型 -->
          <el-table-column min-width="90px" label="评审类型" align="center">
            <template slot-scope="scope">
              {{ ['日常评审', '年度评审'][scope.row.type - 1] }}
            </template>
          </el-table-column>
          <!-- 提交时间	 -->
          <el-table-column min-width="100px" label="提交时间" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.selfAssessmentTime"> {{ moment(scope.row.selfAssessmentTime).format('YYYY-MM-DD') }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <!-- 评审模块	 -->
          <el-table-column prop="moduleName" min-width="90px" label="评审模块	" align="center"></el-table-column>
          <!-- 查看评审明细	 -->
          <el-table-column min-width="70px" label="查看评审明细" align="center">
            <template slot-scope="scope">
              <el-button v-if="scope.row.isChiefReviewer == 1" type="text" @click.stop="handleReview(scope.row)">查看评审明细</el-button>
              <span class="orange" v-else>联系主评审</span>
              <!-- {{ ['是', '否'][scope.row.isChiefReviewer - 1] }} -->
            </template>
          </el-table-column>
          <el-table-column min-width="140px" label="操作" align="center">
            <template slot-scope="scope">
              <!--  {{ ['企业待自评', '专家待分配', '专家评审中', '已截止', '已完成'][scope.row.status - 1] }} -->
              <el-button v-if="scope.row.expertStatus == 1" type="text" @click.stop="rowClick(scope.row, 1)">前往评审</el-button>
              <el-button v-if="scope.row.status == 4" type="text" @click.stop="rowClick(scope.row, 2)">查看评审报告</el-button>
              <el-button v-if="scope.row.status == 4" type="text" @click.stop="rowClick(scope.row, 3)">查看证书</el-button>
              <el-button type="text" @click.stop="rowClick(scope.row, 4)">详情</el-button>
            </template>
          </el-table-column>
          <div slot="empty">
            <img src="../../assets/img/emptyData.png" alt="" />
          </div>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="pagination">
        <div>共{{ total }}条数据</div>
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page.sync="parame.page"
          :page-size="parame.limit"
          :pager-count="5"
          layout="total, prev, pager, next"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 手机端 -->
    <div class="fitIpone">
      <h3 style="display: flex">
        评审管理
        <el-input
          @change="getQuestionList"
          @keyup.enter.native="getQuestionList"
          size="small"
          style="width: 50%; margin-left: auto"
          placeholder="请输入你需要搜索的内容"
          v-model="parame.keyWords"
          clearable>
        </el-input>
      </h3>
      <div class="tabs">
        <div class="tabsItem" @click="handleTabs(item)" :class="{ activr: item.id == parame.status }" v-for="(item, index) in tabs.data" :key="`${index}a`">
          {{ item.name }}
        </div>
      </div>
      <div class="listIpone" v-loading="loading" element-loading-text="拼命加载中">
        <template v-if="tableData && tableData.length">
          <!--  ['企业待自评', '专家待分配', '专家评审中', '已截止', '已完成'][item.status - 1] -->
          <div class="listIBox" v-for="(item, index) in tableData" :key="`${index}c`">
            <div class="listIponeItem">
              <div class="left">
                <div class="tiles">
                  <span class="tiltBox" :class="['tileOrruge', 'tileOrruge', 'tileBlue', 'tileRed', 'tileGreen'][item.status - 1]"></span>
                  评审-{{ item.recordNumber }}
                </div>
                <div class="time">
                  截止时间:<span v-if="item.endTime"> {{ moment(item.endTime).format('YYYY.MM.DD HH:mm:ss') }}</span>
                  <span v-else>暂无</span>
                </div>
                <div class="time" v-if="item.userName">
                  用户:<span>{{ item.userName || '--' }}</span>
                </div>
                <div class="time">
                  评审模块:<span>{{ item.moduleName || '--' }}</span>
                </div>
                <div class="isChied" v-if="item.isChiefReviewer == 1" @click.stop="handleReview(item)">查看评审明细</div>
                <div class="box" :class="['DayBox', 'YearBox'][item.type - 1]">{{ ['日常评审', '年度评审'][item.type - 1] }}</div>
              </div>
              <div class="right">
                <el-button
                  @click.stop="rowClick(item, ['', '', 1][item.status - 1])"
                  v-if="parame.status == 1"
                  type="text"
                  :class="['orange', 'orange', 'blue', 'red', 'green'][item.status - 1]"
                  >{{ ['企业待自评', '专家待分配', '专家评审中', '已截止', '已完成'][item.status - 1] }}</el-button
                >
                <el-button @click.stop="rowClick(item, 4)" v-else type="text" :class="['orange', 'orange', 'blue', 'red', 'green'][4]">{{
                  ['企业待自评', '专家待分配', '专家评审中', '已截止', '已完成'][4]
                }}</el-button>
              </div>
            </div>
            <div v-if="item.status == 5">
              <div class="rowList">自评得分：</div>
              <div class="rowList">
                评审得分：{{ item.selfScore }}
                <span class="line"></span>
                设备管理成熟度：{{ item.evaluate }}
                <span class="line"></span>
                星级：{{ item.starLevel }}
              </div>
            </div>
          </div>
        </template>
        <div v-else style="text-align: center">
          <img src="../../assets/img/emptyData.png" alt="" />
        </div>
        <!-- 分页 -->
        <div class="pagination" style="justify-content: flex-end">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page.sync="parame.page"
            :page-size="parame.limit"
            :pager-count="5"
            layout="total, prev, pager, next"
            :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="评分详情" :visible.sync="dialogTableVisible">
      <el-table :data="gridData" v-loading="dialogTableloding">
        <el-table-column property="userName" label="专家"></el-table-column>
        <el-table-column property="moduleName" label="负责模块"></el-table-column>
        <el-table-column property="status" label="评审状态">
          <template slot-scope="scope">
            <span :class="['orange', 'green'][scope.row.status - 1]">{{ ['评审中', '评审完成'][scope.row.status - 1] }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="120px" property="endTime" label="评审时间"></el-table-column>

        <el-table-column property="score" label="总分值"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  name: 'expertAssessIndex',
  components: {},
  data() {
    return {
      loading: false,
      tabs: {
        data: [
          { name: '待评审', id: 1 },
          { name: '评审完成', id: 2 },
        ],
      },
      // 列表数据
      tableData: [],
      total: 0,
      parame: {
        status: 1, // 评审流程状态（1.评审中 2.评审结束）
        keyWords: '',
        page: 1,
        limit: 10,
      },
      gridData: [],
      dialogTableVisible: false,
      dialogTableloding: false,
    };
  },
  watch: {},
  created() {
    this.getQuestionList();
  },
  mounted() {},
  computed: {
    currentUser: function () {
      return this.$store.getters.getCurrentUser;
    },
  },
  methods: {
    moment,
    handleReview(row) {
      console.log(`🚀 ~ row:`, row);
      this.dialogTableloding = true;
      this.dialogTableVisible = true;
      this.$axios.post('api/review/expert', { recordId: row.id }).then((res) => {
        if (res.data.code == 200) {
          // const { currPage, list, pageSize, totalCount, totalPage } = res.data.page;
          // this.total = totalCount;
          // this.tableData = list || [];
          // this.loading = false;
          this.gridData = res.data.data;
          this.dialogTableloding = false;
        } else {
        }
      });
    },
    // 获取题库列表
    getQuestionList() {
      this.loading = true;
      this.$axios.post('api/review/expertList', this.parame).then((res) => {
        if (res.data.code == 200) {
          const { currPage, list, pageSize, totalCount, totalPage } = res.data.page;
          this.total = totalCount;
          this.tableData = list || [];
          this.loading = false;
        } else {
          this.loading = false;
        }
      });
    },
    handleTabs(item) {
      this.parame.page = 1;
      this.parame.status = item.id;
      this.getQuestionList();
    },
    // 列表-分页-变更当前页
    handleCurrentChange(val) {
      this.parame.page = val;
      this.getQuestionList();
    },
    rowClick(item, type) {
      console.log(`🚀 ~ type:`, type);
      console.log(`🚀 ~ item:`, item);
      switch (type) {
        case 1: // 前往自评 / 编辑
          this.$router.push({
            path: '/initiaExpert',
            query: { expertId: item.expertId, selfId: item.selfId },
          });
          break;
        case 2: // 查看评审报告
          if (item.expertUsableNumber > 0 || item.expertUsableNumber == null) {
            window.open(`${this.report}/report.html?selfId=${item.selfId}`, '_blank');
            this.common.reportsNumber(1);
            this.getQuestionList();
          } else {
            this.$message({
              message: `使用次数不足，请联系管理员！`,
              type: 'error',
              offset: 80,
            });
          }
          break;
        case 3: // 查看证书
          break;
        case 4: // 详情
          this.$router.push({
            path: '/expertDeil',
            query: { expertId: item.expertId, id: item.id, selfId: item.selfId },
          });
          break;

        default:
          // this.$router.push({
          //   path: '/expertDeil',
          //   query: { expertId: item.expertId, id: item.id, selfId: item.selfId },
          // });
          break;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.tabs {
  display: flex;
  margin: 15px 0;
  font-size: 14px;
  .tabsItem {
    margin-right: 15px;
    padding-bottom: 6px;
    cursor: pointer;
  }
  .activr {
    color: #1784fc;
    position: relative;
    bottom: 0;
    left: 0;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      width: 100%;
      left: 0;
      border-bottom: 2px solid #1784fc;
    }
  }
}
.listIpone {
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  border: 1px solid #ebecf1;
  background: #fbfdff;
  padding: 15px;
  .listIBox {
    margin-bottom: 20px;
  }
  .listIponeItem {
    display: flex;
    align-items: center;
    margin-bottom: 4px;
    position: relative;
    // cursor: pointer;
    .isChied {
      position: absolute;
      right: 0;
      top: 0;
      font-size: 12px;
      background-color: #f68e6d;
      border-radius: 6px;
      padding: 3px 6px;
      color: #fbfdff;
    }
    .left {
      .tiles {
        color: #4f5d77;
        font-size: 18px;
        font-weight: 500;
        margin-bottom: 4px;
        display: flex;
        align-items: center;
        .tiltBox {
          width: 6px;
          height: 6px;
          margin-right: 8px;
          display: inline-block;
        }
        .tileOrruge {
          background: #f68e6d;
        }
        .tileRed {
          background: #df5151;
        }
        .tileBlue {
          background: #499bde;
        }
        .tileGreen {
          background: #5b9f7b;
        }
      }
      .time {
        color: rgba(79, 93, 119, 0.6);
        line-height: 25px;
        span {
          color: #4f5d77;
          font-size: 14px;
          font-weight: 500;
          letter-spacing: 0.01px;
        }
      }
      .box {
        width: 76px;
        height: 25px;
        text-align: center;
        line-height: 25px;
        border-radius: 18px;
        font-size: 12px;
        margin-top: 4px;
      }
      .DayBox {
        border-radius: 18px;
        background: rgba(79, 93, 119, 0.16);
        color: rgba(79, 93, 119, 0.7);
      }
      .YearBox {
        border-radius: 18px;
        background: rgba(62, 123, 250, 0.16);
        color: rgba(62, 123, 250, 0.7);
      }
    }
    .right {
      margin-left: auto;
    }
  }
  .rowList {
    color: rgba(79, 93, 119, 0.6);
    font-size: 14px;
    line-height: 25px;
  }
}
</style>

<style lang="less" scoped>
/* PC端样式 */
@media only screen and (min-width: calc(700px + 1px)) {
  #expertAssessIndex {
    .fitPc {
      display: block;
    }
    .fitIpone {
      display: none;
    }
  }
}

/* 移动端样式 */
@media only screen and (max-width: 700px) {
  #expertAssessIndex {
    .fitPc {
      display: none;
    }
    .fitIpone {
      display: block;
    }
  }
  /deep/ .el-dialog {
    width: 95% !important;
  }
}
</style>
